module.exports = __webpack_public_path__ + "static/media/100_12.1e0889af.jpg";